import * as React from "react";
import BOSubMenuEntry from "./BOSideItem/BOSideItemSub";
import { SideOption } from "./BOSide";

type Props = {
  clearStates: () => void;
  selectedOption: SideOption;
};

export default class BOSideSubMenu extends React.Component<Props, {}> {
  renderStaticSideMenu = () => {
    const subMenu: { text: string; link: string }[] = this.props.selectedOption
      .menuItems;

    const subMenuEntries = subMenu.map((val: any, key: number) => {
      const shown = () => {
        if (val.if) {
          let returnVal = false;
          val.if.map((auth, keyRow) => {
            if (this.state[auth]) {
              returnVal = true;
            }
            return "1";
          });
          return returnVal;
        } else {
          return true;
        }
      };

      return (
        <BOSubMenuEntry
          key={key}
          visible={shown()}
          clearStates={this.props.clearStates}
          link={val.link}
          text={val.text}
        />
      );
    });
    return <div>{subMenuEntries}</div>;
  };

  render() {
    if (this.props.selectedOption) {
      return <ul id="BOSideSub">{this.renderStaticSideMenu()}</ul>;
    } else {
      return null;
    }
  }
}
